import { render, staticRenderFns } from "./changeBusiness.vue?vue&type=template&id=14333840&"
import script from "./changeBusiness.vue?vue&type=script&lang=js&"
export * from "./changeBusiness.vue?vue&type=script&lang=js&"
import style0 from "./changeBusiness.vue?vue&type=style&index=0&id=14333840&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports